import { render, staticRenderFns } from "./manual_create_details.vue?vue&type=template&id=54a61397&scoped=true"
import script from "./manual_create_details.vue?vue&type=script&lang=js"
export * from "./manual_create_details.vue?vue&type=script&lang=js"
import style0 from "./manual_create_details.vue?vue&type=style&index=0&id=54a61397&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a61397",
  null
  
)

export default component.exports